import * as React from 'react'

export interface FroalaEditorViewProps {
    model?: any
    tag?: any
}

export class FroalaEditorView extends React.Component<FroalaEditorViewProps> {
    private defaultTag: string
    private tag: string = ''

    constructor(props: any) {
        super(props)

        this.defaultTag = 'div'
    }

    getTrustedHtml() {
        return { __html: this.props.model }
    }

    render() {
        this.tag = this.props.tag || this.defaultTag
        const Test: any = this.tag
        return (
            <Test
                className="fr-view"
                dangerouslySetInnerHTML={this.getTrustedHtml()}
            ></Test>
        )
    }
}
